// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0c931001","70":"162b06c9","71":"604834c2","195":"baa49c26","293":"c18e387e","349":"9dacecd5","360":"974909bc","401":"c200822b","419":"83a84a5b","606":"39d52daf","621":"2453dff2","832":"0f5764a6","870":"4512ba83"}[chunkId] + ".chunk.js";
};